export const faq = [
    {
        question: "When is the hackathon?",
        answer: "The hackathon will take place on April 26 from 9:00am to 5:00pm."
    },
    {
        question: "How can I find the hackathon?",
        answer: "The hackathon will take place in Park Boulevard, which is a meeting room on the first floor of the Conrad Prebys Aztec Student Union."
    },
    {
        question: "What should I bring with me on the day of the hackathon?",
        answer: "You should bring your laptop and a charging cable with you to the hackathon. Food and refreshments will be provided, but you are welcome to bring your own food."
    },
    {
        question: "What kind of food will there be at the hackathon?",
        answer: "We will serve donuts and coffee for breakfast, and pizza and sandwiches for lunch."
    },
    {
        question: "What are some of the prizes available for winners?",
        answer: "Top prizes include a Raspberry Pi mini computer, Apple AirPods, Steam gift cards, and more!"
    }
]